import { Component, OnInit, Input, Output, EventEmitter, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { fciWebsiteService } from '../../service/fci-website.service';
import { CustomServiceService } from '../../service/custom-service.service';
import { EncryptDecryptService } from '../../service/encrypt-decrypt.service';
import { HttpEvent, HttpEventType } from '@angular/common/http';
// import { ConsoleReporter } from 'jasmine';
import { environment } from 'src/environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
declare let $: any;
import * as CryptoJS from "crypto-js";
import { Buffer } from 'buffer';
import { TranslateService } from '@ngx-translate/core';
@Component({ 
  selector: 'app-depot-details',
  templateUrl: './depot-details.component.html',
  styleUrls: ['./depot-details.component.css']
})
export class DepotDetailsComponent implements OnInit {

  constructor(private fciwebservice: fciWebsiteService, private httpservice: CustomServiceService, private routerparam: ActivatedRoute, private encDec: EncryptDecryptService, public translate: TranslateService) { }

  backend_url: any = environment.serviceURL;
  btncontent: any = `Search`;
  language:any = sessionStorage.getItem('locale');//dynamic


  // sortmenu:any;
  ngOnInit(): void {
    console.clear();
    document.title = "Depot Details";
    this.DepotList('', '', '');
    this.ZoneList();
  }

  ngAfterViewInit(): void {
    //FOR SCROLLING TO TOP WHEN COMPONENT LOADS
    // $('html, body').scrollTop(0);
  }

  searchForm = new FormGroup({
    zone: new FormControl(''),
    region: new FormControl(''),
    depot: new FormControl(''),
  })

  get depot() {
    return this.searchForm.get('depot');
  }
  get zone() {
    return this.searchForm.get('zone');
  }
  get region() {
    return this.searchForm.get('region');
  }
  RefreshBtn: boolean = false;
  RefreshPage() {
    this.RefreshBtn = false;
    this.searchForm.reset();
    $('select#zone').prop('selectedIndex', 0);
    $('select#region').prop('selectedIndex', 0);
    $('select#depot').prop('selectedIndex', 0);
    this.DepotList('', '', '');
  }

  zone_apirespons: any;
  zoneList: any[] = [];
  ZoneList() { 
    this.httpservice.getZoneList().subscribe((response: HttpEvent<any>) => {
      switch (response.type) { 
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          // this.zone_apirespons = response.body;
          // this.zoneList = this.zone_apirespons.data;
          this.region_apirespons = response.body.RESPONSE_DATA;
          let res = JSON.parse(Buffer.from(this.region_apirespons, 'base64').toString());
          this.zoneList  = res.original.data;
      }
    });
  }  
 
  region_apirespons: any;
  regionList: any[] = [];
  GetRegion(data:any){
    this.regionList = [];
    let p = {'zone_id':data.value};
    if(data.value==""){
      return;
    }
    this.httpservice.GetRegionByZoneId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.region_apirespons = response.body.RESPONSE_DATA;
          let res = JSON.parse(Buffer.from(this.region_apirespons, 'base64').toString());
          this.regionList  = res.original.data;
      }
    });
  }


  depot_apirespons: any;
  depotList: any[] = [];
  GetDepot(data: any) {
    this.depotList = [];
    $('select#depot').prop('selectedIndex', 0);
    if (data.value == "") {
      return;
    }
    let p = {'region_id':data.value};
    this.httpservice.GetDepotByRegionId(p).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          // this.depot_apirespons = response.body;
          // this.depotList = this.depot_apirespons.data;
          this.depot_apirespons = response.body.RESPONSE_DATA;
          let res = JSON.parse(Buffer.from(this.depot_apirespons, 'base64').toString());
          this.depotList  = res.original.data;
      }
    });
  }

  searchTender() {
    let param_arr = [];
    if (this.searchForm.value.depot !== "") {
      if (this.searchForm.value.depot !== null) {
        param_arr.push(this.searchForm.value.depot);
      }
    }
    if (this.searchForm.value.zone !== "") {
      if (this.searchForm.value.zone !== null) {
        param_arr.push(this.searchForm.value.zone);
      }
    }
    if (this.searchForm.value.region !== "") {
      if (this.searchForm.value.region !== null) {
        param_arr.push(this.searchForm.value.region);
      }
    }
    if (param_arr.length <= 0) {
      if(this.language=='English'){
        alert('Please select at least one parameter');
      }else{
        alert('कृपया कम से कम एक पैरामीटर चुनें');  
      }
      return; 
    } 
    this.RefreshBtn = true;
    this.DepotList(this.searchForm.value.zone, this.searchForm.value.region, this.searchForm.value.depot);
  }
  ifdisabled: boolean = false;
  apirespons: any;
  deoptList: any[] = [];
  DepotList(zoneid: any, region: any, depot: any) {
    var query = [];
    query = [
      { "columnName": "tinPublishStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      // { "columnName": "tinActiveStatus", "operator": "=", "value": "1", "joinoperator": "and" },
      { "columnName": "bitDeletedFlag", "operator": "=", "value": "0", "joinoperator": "and" },
    ];
    if (zoneid !== "") {
      query.push({ "columnName": "INT_ZONE_ID", "operator": "LIKE", "value": zoneid, "joinoperator": "and" });
    }
    if (region !== "") {
      query.push({ "columnName": "INT_REGION_ID", "operator": "=", "value": region, "joinoperator": "and" });
    }
    if (depot !== "") {
      query.push({ "columnName": "INT_DEPOT_ID", "operator": "=", "value": depot, "joinoperator": "and" });
    }
    let params = [
      {
        "secSlNo": 1,
        "offSet": 0,
        "noOfRecords": 0,
        "orderBy": [],//{ "columnName": "VCHMENUNAME", "type": "asc" }
        "condition": query,
        "viewParameters": ""
      }];
    this.httpservice.getDepotList(params).subscribe((response: HttpEvent<any>) => {
      switch (response.type) {
        case HttpEventType.Sent:
          //console.log('Sent' + HttpEventType.Sent);
          break;
        case HttpEventType.ResponseHeader:
          //console.log('ResponseHeader' + HttpEventType.ResponseHeader);
          break;
        case HttpEventType.UploadProgress:
          //this.evenTotal = response.total;
          //this.progress = Math.round(response.loaded / this.evenTotal * 100);
          break;
        case HttpEventType.Response:
          this.apirespons = response.body;
          this.apirespons = response.body;
          let respData = this.apirespons.RESPONSE_DATA;
          let respToken = this.apirespons.RESPONSE_TOKEN;
          let verifyToken = CryptoJS.HmacSHA256(respData,environment.apiHashingKey).toString();
          if (respToken == verifyToken) {
            let response: any = Buffer.from(respData, 'base64');
            response = JSON.parse(response);
            this.deoptList = response.result.sec_1;
          } 
      }
    });
  }



  jsonConvert(data: any, type: any) {
    let d = JSON.parse(data.jsonOptTxtDetails);
    if (type == 'INT_ZONE_ID') {
      return d.INT_ZONE_ID;
    } else if (type == 'INT_REGION_ID') {
      return d.INT_REGION_ID;
    } else if (type == 'INT_DEPOT_ID') {
      return d.INT_DEPOT_ID;
    } else {
      return '';
    }
  }

  htmlTag(data: any) {
    return this.encDec.decodeHtml(data);
  }

  encode(data: any) {
    return btoa(data);
  }












  
}
